module.exports = __webpack_public_path__ + "img/loading-quote-img-2.2db7bdda.png";